function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { getAuth } from "firebase/auth";
import { collection, doc, getFirestore, onSnapshot } from "firebase/firestore";
import { activeEventsClient } from "../generated/active_events";
import { ensureClientInitialized } from "./firebase";
import { parseActiveEventFromDocument } from "./types/activeEvents";
var FIREBASE_APP_NAME = "Global";
var unsubscribeFunctions = [];
var fetchFirebaseConfig = function() {
    var _ref = _asyncToGenerator(function() {
        var ref, firebaseConfig;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        activeEventsClient.activeEventService.getActiveEventsFirebaseConfig({})
                    ];
                case 1:
                    firebaseConfig = _state.sent();
                    return [
                        2,
                        {
                            authToken: firebaseConfig.authToken,
                            options: firebaseConfig.config,
                            proxyDomain: ((ref = firebaseConfig.config) === null || ref === void 0 ? void 0 : ref.proxyDomain) || ""
                        }
                    ];
            }
        });
    });
    return function fetchFirebaseConfig() {
        return _ref.apply(this, arguments);
    };
}();
export var setActiveEventsListener = function() {
    var _ref = _asyncToGenerator(function(listener) {
        var firebaseConfig, isLoggedIn, firebaseClient, auth, activeEventFirestoreClient;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchFirebaseConfig()
                    ];
                case 1:
                    firebaseConfig = _state.sent();
                    isLoggedIn = firebaseConfig.authToken && firebaseConfig.authToken.length > 0;
                    if (!isLoggedIn) {
                        // Skip initialization for anonymous users.
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        ensureClientInitialized(FIREBASE_APP_NAME, firebaseConfig)
                    ];
                case 2:
                    firebaseClient = _state.sent();
                    auth = getAuth(firebaseClient);
                    if (!auth.currentUser) {
                        return [
                            2
                        ];
                    }
                    activeEventFirestoreClient = new ActiveEventFirestoreClient(firebaseClient);
                    unsubscribeFunctions.push(onSnapshot(activeEventFirestoreClient.getActiveEventsCollection(auth.currentUser.uid), function(q) {
                        var events = q.docs.map(function(d) {
                            return parseActiveEventFromDocument(d);
                        });
                        listener(events.filter(function(ev) {
                            return ev != null;
                        }));
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return function setActiveEventsListener(listener) {
        return _ref.apply(this, arguments);
    };
}();
export var clearActiveEventsListeners = function() {
    unsubscribeFunctions.forEach(function(unsubscribe) {
        return unsubscribe();
    });
    unsubscribeFunctions = [];
};
var ActiveEventFirestoreClient = function ActiveEventFirestoreClient(app) {
    "use strict";
    var _this = this;
    _classCallCheck(this, ActiveEventFirestoreClient);
    this.getUserDocument = function(userId) {
        return doc(collection(getFirestore(_this.app), "users"), userId);
    };
    this.getActiveEventsCollection = function(userId) {
        return collection(_this.getUserDocument(userId), "activeEvents");
    };
    this.app = app;
};
